<template>
    <section class="notes" ref="card">
        <slot name="content" :open="open">

        </slot>
        <dialog id="size-chart" ref="dialog" class="fixed">
            <button class="close icon" @click.prevent="close"><span class="ir visuallyhidden">Close Dialog</span></button>
            <div class="container">
                <button class="icon" @click.prevent="close">
                    <inline-svg src="/images/svg/close-icon.svg" />
                </button>
                <slot name="dialog">

                </slot>
            </div>
        </dialog>
    </section>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import InlineSvg from 'vue-inline-svg';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const frameCount = 3
const data = {
    frame:0
}
let currentFrame = -1;
let images = [];
let tabs = [];

const card = ref(null);
const dialog = ref(null);

const open = () => {
    dialog.value.showModal();
    dialog.value.querySelector('button.close').blur();
}

const close = () => {
    dialog.value.close();
}

const toggleSwap = () => {
    if(currentFrame != data.frame){
        card.value.querySelectorAll('.active').forEach(s => s.classList.remove('active'));
        images.item(data.frame).classList.add('active');
        tabs.item(data.frame).classList.add('active');
        currentFrame = data.frame;
    }
}

onMounted(() => {

    images = card.value.querySelectorAll('.grid .images img');
    tabs = card.value.querySelectorAll('.grid .tabs .tab');

    let tl = gsap.timeline({
        defaults:{
            duration:0.5
        },
        scrollTrigger:{
            trigger:card.value,
            start:() => {
                return 'top top+='+document.querySelector('header.main nav').clientHeight;
            },
            end:() => '+=1000',
            pin:true,
            scrub:1
        }
    });

    tl.to(data, {
        frame:frameCount - 1,
        snap:'frame',
        ease:'none',
        onUpdate:toggleSwap,
        duration:2.5
    });
})

</script>
